/**
 * Did the API say this CUSTOMER does not exist — as opposed to any other way
 * loading the page can fail?
 *
 * The distinction matters because the customer page cannot render on undefined
 * data (every tab reads `customer.data?.info`), so it has to show something
 * else — and "Page Not Found" is a claim about the customer, not about the
 * request. `/api/v2/company/customers/:id` answers:
 *
 *   404 { error: "Customer not found" }   the id is not a customer of this business
 *   404 { error: "BUSINESS_NOT_FOUND" }   the session has no business attached
 *   401 { error: "USER_NOT_FOUND" }       auth failed
 *   500 { error: "invalid input ..." }    a non-numeric id reached Postgres
 *
 * Only the first is a missing customer. Treating all of them as one told a user
 * whose session had no business that a customer they were looking at did not
 * exist.
 */
export function isCustomerNotFound(error: unknown): boolean {
  const e = error as { response?: { status?: number; data?: { error?: string } } } | undefined;
  return e?.response?.status === 404 && e?.response?.data?.error === "Customer not found";
}
